export default __webpack_public_path__ + "static/media/audio.a67b6c14.svg";